import Conviva from './Conviva';

/*! (C) 2016 Conviva, Inc. All rights reserved. Confidential and proprietary. */
/*! This is sample code meant to illustrate proper Conviva integration in video applications. */
/*! This file should not be included in video applications as part of integrating Conviva. */

// Implements Conviva.LoggingInterface for Chrome.

class Html5Logging implements Conviva.LoggingInterface {
    public consoleLog(
        message: string,
        logLevel: Conviva.SystemSettings.LogLevel
    ): void {
        if (typeof console === 'undefined') return;

        if (
            console.log && logLevel === Conviva.SystemSettings.LogLevel.DEBUG ||
            logLevel === Conviva.SystemSettings.LogLevel.INFO
        ) {
            // tslint:disable-next-line:no-console
            console.log(message);
        } else if (
            console.warn &&
            logLevel === Conviva.SystemSettings.LogLevel.WARNING
        ) {
            console.warn(message);
        } else if (
            console.error &&
            logLevel === Conviva.SystemSettings.LogLevel.ERROR
        ) {
            console.error(message);
        }
    }

    public release(): void { /* */ }
}

export default Html5Logging;
